/* @jsx h */
import { defineComponent, h, onMounted } from "vue";
import { RouterView } from "vue-router";
import { useTheme } from "@lemmonhq/uikit";
import { useGroupAuth } from "@app/vue/providers/GroupAuth";

// Group-mode counterpart to `Application` (the `/app` shell). Mounted at
// `/group`, it themes and hosts the nested group RouterView so the group
// routes mirror the `/app` parent/child structure.
export const GroupApplication = defineComponent({
  name: "GroupApplication",
  setup() {
    onMounted(() => {
      const styleString = `html, body {  scrollbar-gutter: initial !important; overflow: hidden; }`;
      const style = document.createElement("style");
      style.textContent = styleString;
      (document as any).head.append(style);
    });
    const auth = useGroupAuth();
    const { currentTheme } = useTheme();

    return () => {
      if (auth.identity.value) {
        return (
          <div
            data-theme={currentTheme.value}
            style={{
              height: `calc(100vh - 64px - var(--safe-area-top, 0px))`,
            }}
            class="flex flex-col overflow-hidden"
          >
            <RouterView />
          </div>
        );
      }
      return null;
    };
  },
});
